// extracted by mini-css-extract-plugin
export default {"grid":"MainGrid_grid__rfcqK","addItemTile":"MainGrid_addItemTile__wygCl"};